<div class="p-4">
    <h3 class="font-bold mb-4">Materias primas cargadas en máquina</h3>

    <nz-table [nzData]="items" [nzLoading]="loading" nzSize="small">
        <thead>
            <tr>
                <th>Artículo</th>
                <th>Lote</th>
                <th>Packaging</th>
                <th>Cantidad registrada</th>
                <th>Precargar</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items">
                <td>{{ item.rawMaterialUsed?.article?.name || '-' }}</td>
                <td>{{ item.rawMaterialUsed?.articleBatch?.batchNumber || item.rawMaterialUsed?.articleBatchId || '-' }}</td>
                <td>{{ item.rawMaterialUsed?.usedPackaging?.externalBatchNumber || '-' }}</td>
                <td>{{ item.rawMaterialUsed?.rawQuantity || '-' }}</td>
                <td>
                    <label nz-checkbox [(ngModel)]="item.preload" [nzDisabled]="!allowPreload">Sí</label>
                </td>
            </tr>
        </tbody>
    </nz-table>

    <div class="mt-4 flex justify-end">
        <button nz-button class="button secondary-button mr-2" (click)="cancel()">Cancelar</button>
        <button nz-button class="button primary-button" (click)="apply()" [disabled]="loading">Aplicar</button>
    </div>
</div>
